<template>
  <v-layout>
    <v-row>
      <v-col>
        <v-text-field
          label="Busca de paciente"
          prepend-inner-icon="eva-search-outline"
          v-model="search"
          dense
          outlined
          background-color="white"
          clearable
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          dark
          color="light-blue"
          :loading="refreshing"
          @click="refreshQueue"
        >
          <v-icon class="mr-2" small>eva-refresh-outline</v-icon>
          <span>Atualizar Fila</span>
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="attendances === null">
      <v-row v-for="index in 4" :key="index">
        <v-col cols="12">
          <v-card rounded="lg">
            <v-container fluid>
              <v-row dense align="center" justify="space-around">
                <v-col cols="1">
                  <v-skeleton-loader
                    type="avatar"
                    transition="fade-transition"
                  />
                </v-col>

                <v-col cols="4">
                  <v-skeleton-loader
                    type="list-item-three-line"
                    transition="fade-transition"
                  />
                </v-col>

                <v-col cols="3">
                  <v-skeleton-loader
                    type="list-item-three-line"
                    transition="fade-transition"
                  />
                </v-col>

                <v-col cols="2">
                  <v-skeleton-loader type="chip" transition="fade-transition" />
                </v-col>

                <v-col cols="auto">
                  <v-skeleton-loader
                    type="button"
                    transition="fade-transition"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div v-else-if="lodash.isEmpty(attendances)">
      <v-row justify="center">
        <v-col cols="4">
          <v-alert color="orange" outlined text type="info">
            Sem atendimentos nessa fila
          </v-alert>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row v-for="item in attendancesFiltered" :key="item.id">
        <v-col cols="12">
          <attendance
            :attendance="item"
            :medicalRecordPath="medicalRecordPath"
            :refreshQueue="refreshQueue"
          >
            <template v-slot:details="{ attendance }">
              <slot
                name="attendance"
                :attendance="attendance"
                :refreshQueue="refreshQueue"
              >
              </slot>
            </template>
          </attendance>
        </v-col>
      </v-row>
    </div>
  </v-layout>
</template>

<script>
import GET_ATTENDANCES from "@/graphql/attendances";
import attendance from "@/components/queues/attendance.vue";

export default {
  name: "Attendances",
  components: {
    attendance,
  },
  props: {
    queueType: String,
    medicalRecordPath: String,
    attendancePlaceId: {
      type: String,
      default: "",
    },
    employeeId: {
      type: String,
      default: "",
    },
    pollInterval: {
      type: Number,
      default: 20000, // padrão é 20000 (20 segundos)
    },
  },
  data() {
    return {
      attendances: null,
      attendanceHeight: 132,
      dayOfAttendance: new Date().toISOString().slice(0, 10),
      search: "",
      refreshing: false,
    };
  },
  apollo: {
    attendances: {
      query: GET_ATTENDANCES,
      deep: true,
      variables() {
        return {
          queueType: this.queueType,
          attendancePlaceId: this.attendancePlaceId,
          employeeId: this.employeeId,
          dayOfAttendance: this.dayOfAttendance,
        };
      },
      pollInterval() {
        return Number(this.pollInterval);
      },
    },
  },
  mounted() {
    this.refreshQueue();
  },
  computed: {
    attendancesFiltered() {
      if (!this.search) {
        return this.attendances;
      }

      return this.lodash.filter(
        this.attendances,
        function(e) {
          let search = String(this.search)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          let name = String(e.patient.name)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          let warelineId = String(e.patient.warelineId)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

          return name.includes(search) || warelineId.includes(search);
        }.bind(this)
      );
    },
    attendancesList() {
      return this.lodash.orderBy(
        this.attendancesFiltered,
        ["name", "asc"],
        ["warelineId", "asc"]
      );
    },
  },
  methods: {
    async refreshQueue() {
      this.refreshing = true;
      await this.$apollo.queries.attendances.refetch();
      this.refreshing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.attendance-header {
  color: var(--v-secondary2-base);
}
</style>
